module.exports = __webpack_public_path__ + "assets/1a8de2d625dc6f918e20ccf01f4c953b.png";